import { render } from "./BrandTyreRangeTyres.vue?vue&type=template&id=3e7c3fac"
import script from "./BrandTyreRangeTyres.vue?vue&type=script&lang=js"
export * from "./BrandTyreRangeTyres.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__